import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import GET_GUESS_WHO_ACTIVITY from '../../queries/activities/guess-who-query';
import { StoreTypename } from 'types';
import { GuessWhoActivity as GuessWho } from '@monorepo/shared/src/graph/schema-generated-types-student';

const DEFAULT_BOOK_EDTION = 2022;

export type GuessWhoActivityState = {
  activity: any;
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type GuessWhoActivityDispatch = undefined;
export type GuessWhoActivity = [GuessWhoActivityState, GuessWhoActivityDispatch];

export const GuessWhoActivity = (): { __typename: string } => ({
  __typename: StoreTypename.GUESS_WHO_ACTIVITY,
});

const useGuessWhoActivityStore = (bookCode: string, edition?: number): GuessWhoActivity => {
  const { data, loading, error }: QueryResult<{ guessWho: GuessWho | undefined }> = useQuery(
    GET_GUESS_WHO_ACTIVITY,
    {
      variables: { where: { book: { bookCode, edition: edition || DEFAULT_BOOK_EDTION } } },
    }
  );

  return [
    {
      activity: data?.guessWho || null,
      error,
      isLoading: loading,
    },
    undefined,
  ];
};

export default useGuessWhoActivityStore;
